import React from 'react';
import { ProgressSpinner } from 'primereact/progressspinner';

interface LoadingProps {
  message?: string;
  size?: 'small' | 'normal' | 'large';
  fullScreen?: boolean;
}

export const Loading: React.FC<LoadingProps> = ({
  message = 'Loading...',
  size = 'normal',
  fullScreen = false,
}) => {
  const spinnerSize = size === 'small' ? '2rem' : size === 'large' ? '4rem' : '3rem';
  
  const containerClass = fullScreen
    ? 'flex align-items-center justify-content-center min-h-screen surface-ground'
    : 'flex align-items-center justify-content-center p-4';

  return (
    <div className={containerClass}>
      <div className="text-center">
        <ProgressSpinner
          style={{ width: spinnerSize, height: spinnerSize }}
          strokeWidth="8"
          fill="var(--surface-ground)"
          animationDuration=".5s"
        />
        <p className="mt-3 text-600">{message}</p>
      </div>
    </div>
  );
};
